<template>
  <div class="my-pooq-content-body">
    <portal to="delete-edit-header" v-if="movieList.length > 0">
      <my-pooq-history-header :change-mode="changeMode" :checked-count="checkedCount" :delete-all="deleteAll"
                              :delete-selected="deleteSelected" :is-delete-mode="isDeleteMode" :total-count="totalCount" view-type="movie"/>
    </portal>
    <div class="mypooq-list"
         ref="mypooq-list-movie"
         v-infinite-scroll="loadMore"
         :infinite-scroll-distance="200"
         :infinite-scroll-throttle-delay="200">
        <my-pooq-empty-list v-if="showEmptyList" info-text="영화 시청내역이 없어요."></my-pooq-empty-list>
      <div v-else-if="!showEmptyList">
          <ul class="seen-list">
            <li v-for="(movieItem, index) in movieList" :key="movieItem.movieid + index">
              <span class="list-select" v-if="isDeleteMode" @click.prevent="()=>toggleMovieCheck(movieItem)">
                <input type="checkbox" :id="'select-btn_' + index" class="select-btn" v-model="movieItem.check">
                <label :for="'select-btn_' + index">
                  <span class="a11y-hidden">내역 체크박스</span>
                    <CheckOn v-if="movieItem.check"/>
                    <CheckOff v-if="!movieItem.check"/>
                 </label>
              </span>
              <a href="#" @click.prevent="goPlayer(movieItem)">
                <div :class="getWrapperClass(movieItem, 'picture-area portrait')">
                  <WebpImage :image-info="{imageUrl: movieItem.image, width: 176, height: 264, alt: movieItem.title}" />
                  <age-tag :age-code="''+movieItem.targetage" content-type="mypooq" class="tag-age"></age-tag>
                  <span class="progress-wrap">
                    <span class="progress-bar" v-progress-bar="movieItem.viewratio * 100"></span>
                  </span>
                </div>
                <span class="thum-info">
                  <strong class="thum-title">{{movieItem.title}}</strong>
                  <span class="thum-date">
                    <span>이용일시</span>
                    <i class="icon-dotted"></i>
                    <span>{{movieItem.viewdate}}</span>
                  </span>
                </span>
              </a>
            </li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { MyPooqService } from '@/common/api/api.service'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import { infiniteScroll, progressBar } from '@/common/directives'
import { get } from 'lodash'
import CheckOn from '@/assets/svg/common/ic-check-on.svg'
import CheckOff from '@/assets/svg/common/ic-check-off.svg'
import MyPooqHistoryHeader from '@/components/lnb/mypooq/MyPooqHistoryHeader'
import {
  COOKIE_KEY_VERIFIED_ADULT,
  MAX_SELECT_COUNT,
  SET_EDITOR_VIEW_CLASS
} from '@/common/constant'
import AgeTag from '@/components/tags/AgeTag'
import utils from '@/common/util/utils'
import { PATH_NAME_PLAYER } from '@/common/router.const'
import { EventBus } from '@/components/eventbus/EventBus'
import WebpImage from '@/components/image/WebpImage'

export default {
  name: 'MyPooqUseListHistoryMovie',
  components: {
    WebpImage,
    MyPooqHistoryHeader,
    CheckOn,
    CheckOff,
    MyPooqEmptyList,
    AgeTag
  },
  directives: {
    infiniteScroll,
    progressBar
  },
  data () {
    return {
      offset: 0,
      limit: 20,
      isDeleteMode: false,
      showEmptyList: false,
      endOfList: false,
      totalCount: 0,
      movieList: [],
      device: utils.cookies.getDevice(),
      adultConfirm: utils.cookies.getItem(COOKIE_KEY_VERIFIED_ADULT) === '1',
      isLoading: false
    }
  },
  computed: {
    checkedCount () {
      return this.movieList.filter(movie => movie.check).length
    }
  },
  methods: {
    toggleMovieCheck (movieItem) {
      if (this.checkedCount >= MAX_SELECT_COUNT) {
        if (get(movieItem, 'check', false)) {
          movieItem.check = !movieItem.check
        }
        if (this.checkedCount >= MAX_SELECT_COUNT) {
          utils.alert(`최대 ${MAX_SELECT_COUNT}개 까지만 선택할 수 있습니다.`)
        }
      } else {
        movieItem.check = !movieItem.check
      }
    },
    goPlayer (movieItem) {
      if (this.device === 'mobile') {
        this.$router.push({
          name: PATH_NAME_PLAYER,
          params: {
            section: 'movie'
          },
          query: {
            movieid: movieItem.movieid,
            referer: this.$route.fullPath
          }
        })
      } else {
        location.href = 'captvpooq://player/movie?movieid=' + movieItem.movieid
      }
    },
    deleteSelected () {
      const checkedList = this.movieList.filter((item) => {
        return item.check
      }).map((item) => {
        return {
          contentid: item.movieid,
          programid: 'MOVIE'
        }
      })
      if (checkedList.length > 0) {
        MyPooqService.deleteHistory({
          contenttype: 'movie',
          contentinfo: checkedList
        }).then(({ data }) => {
          this.movieList = []
          this.offset = 0
          this.totalCount = 0
          this.$nextTick(() => {
            this.setData()
          })
        })
      }
    },
    deleteAll () {
      MyPooqService.deleteHistoryAll({ contenttype: 'movie', updatevalue: 'y' }).then(({ data }) => {
        if (data.resultmessage === 'success') {
          this.movieList = []
          this.offset = 0
          this.totalCount = 0
          this.$nextTick(() => {
            this.setData()
          })
        }
      })
    },
    changeMode () {
      if (this.isDeleteMode) { // off 시킬때
        this.movieList = this.movieList.map((movie) => {
          movie.check = false
          return movie
        })
      }
      this.isDeleteMode = !this.isDeleteMode
    },
    loadMore () {
      if (this.endOfList) return
      if (this.isLoading) return
      this.setData()
    },
    setData () {
      if (this.isLoading) return
      this.isLoading = true
      MyPooqService.watchHistory({
        limit: this.limit,
        offset: this.offset,
        orderby: 'new',
        contenttype: 'movie'
      }).then(({ data }) => {
        const resList = get(data, ['0', 'list'], []).map((item) => {
          item.check = false
          return item
        })
        if (this.totalCount === 0) {
          this.totalCount = Number(get(data, ['0', 'pagecount'], 0))
        }
        this.endOfList = resList.length === 0
        this.showEmptyList = this.movieList.length === 0 && resList.length === 0
        this.offset += this.limit
        this.movieList = this.movieList.concat(resList)
        EventBus.$emit(SET_EDITOR_VIEW_CLASS, this.movieList.length !== 0)
        this.isLoading = false
      })
    },
    getWrapperClass (item, defaultClass) {
      if (item.targetage >= 21 && !this.adultConfirm) {
        return defaultClass + ' vod-lock-21'
      } else {
        return defaultClass
      }
    }
  }
}
</script>
<style scoped>
  .select-btn {
    display: none !important;
  }
  .thum-movie {
    position: relative
  }
  .tag-age{
    position: absolute;
    top: 5px;
    right: 5px;
  }
  .vod-lock-21::after{
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8) url(../../../assets/images/ic-thum-age-adult.png) center no-repeat;
    background-size: 44px auto;
  }
</style>
